import { observer, useViewModel } from '@descomplica/microfrontend-react';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import Loading from '../../components/loading';
import ClassifierItem from './components/classifier-item/classifier-item';
import HighlightLiveItem from './components/highlight-live-item/highlight-live-item';
import LiveClassifierItem from './components/live-classifier-item/live-classifier-item';
import { StudyPlanViewModel } from './study-plan.vm';

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    padding: 0 16px;
  }
`;

const Title = styled.h1`
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-size: 56px;
  font-weight: 700;
  line-height: 48px;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 40px;
    line-height: 48px;
  }
`;

export const Home: React.FC = () => {
  const vm = useViewModel(StudyPlanViewModel);
  const navigate = useNavigate();

  useEffect(() => {
    if (vm.shouldRedirectToPaywall) {
      navigate('/exclusive-access');
    }

    if ((vm.shouldRedirectToLibrary || vm.hasError) && !vm.studyPlan) {
      navigate('/library');
    }
  }, [vm.shouldRedirectToPaywall, vm.shouldRedirectToLibrary, vm.hasError, navigate, vm.studyPlan]);

  if (vm.isLoading) {
    return <Loading />;
  }

  const renderLiveStreaming = () => {
    if (!vm.liveStreaming) {
      return null;
    }

    return (
      <HighlightLiveItem
        status={'Rolando Agora'}
        title={vm.liveStreaming.name}
        subtitle={vm.liveStreaming.teacher}
        liveStreaming={vm.liveStreaming}
      />
    );
  };

  const renderLiveClassifier = () => {
    if (vm.studyPlan?.lives.length === 0) {
      return null;
    }

    return <LiveClassifierItem lives={vm.studyPlan?.lives} />;
  };

  const renderStudyPlan = () => {
    return vm.studyPlan?.weeks.map(
      (week) =>
        week.planned.length > 0 && (
          <ClassifierItem totalLessons={vm.studyPlan?.totalLessons} week={week} key={week.order} />
        ),
    );
  };

  return (
    <Container>
      <Title>{vm.studyPlan?.classificationLevel.name}</Title>
      {renderLiveStreaming()}
      {renderLiveClassifier()}
      {renderStudyPlan()}
    </Container>
  );
};

export default observer(Home);
